import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Une erreur est survenue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
      .join(" ");
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

export default api;
